import React from 'react';
import { useBrandClassificationSplineMetrics } from './hooks/useBrandClassificationMetrics';
import TotalTrafficDonutChart from './TotalTrafficDonutChart';
import { TrafficBarCharts } from './TrafficBarCharts';
import Flex from 'src/components/BeaconV2Components/Flex/Flex';
import { brandClassificationResponseToSpline } from '../utils/trafficParsers';
import { getSplineTotals } from 'src/utils/chartUtils';

function getTrafficTotals(
  response: ReturnType<typeof useBrandClassificationSplineMetrics>['response'],
  key: 'organicTraffic' | 'totalTraffic' | 'paidTraffic'
) {
  return getSplineTotals(
    brandClassificationResponseToSpline(response[0], key),
    brandClassificationResponseToSpline(response[1], key),
    { func: 'sum' }
  );
}

/**
 * Donut and bar charts for topics views
 */
export function TotalTrafficTopSectionForTopics() {
  const { response, isLoading } = useBrandClassificationSplineMetrics();

  const { primaryTotal: organicClicks, secondaryTotal: organicClicksComparison } = getTrafficTotals(
    response,
    'organicTraffic'
  );
  const { primaryTotal: paidClicks, secondaryTotal: paidClicksComparison } = getTrafficTotals(response, 'paidTraffic');
  const { primaryTotal: totalClicks, secondaryTotal: totalClicksComparison } = getTrafficTotals(
    response,
    'totalTraffic'
  );

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <TotalTrafficDonutChart
        loading={isLoading}
        dspClicks={0}
        organicClicks={organicClicks}
        otherTraffic={0}
        paidTraffic={paidClicks}
        totalClicks={totalClicks}
      />
      <TrafficBarCharts
        loading={isLoading}
        organicTraffic={{
          current: organicClicks,
          comparison: organicClicksComparison
        }}
        paidTraffic={{
          current: paidClicks,
          comparison: paidClicksComparison
        }}
        otherTraffic={{
          current: 0,
          comparison: 0
        }}
        totalTraffic={totalClicks}
        totalTrafficComparison={totalClicksComparison}
      />
    </Flex>
  );
}
